import _ from 'lodash';

export const OrderStatus = {
  confirmed: {
    status: 'confirmed',
    color: '#87d068',
    title: 'Confirmé',
  },
  cancelled: {
    status: 'cancelled',
    color: 'error',
    title: 'Annulé',
  },
  pending: {
    status: 'pending',
    title: 'En cours',
  },
};

export const PayStatus = {
  pending: {
    status: 'pending',
    color: 'gold',
    title: 'Remboursé',
  },
  paid: {
    status: 'paid',
    color: '#2db7f5',
    title: 'Payé',
  },
  refund: {
    status: 'refund',
    color: 'geekblue',
    title: 'Non payé',
  },
};

export const field_payment_method = [
  'notify_url',
  'identifiant',
  'site',
  'secret_key',
  'error_url',
  'success_url',
  'client_id',
  'merchant_account',
  'client_secret',
];

export const operator_params = [
  'allow_change_order_before_departure', //boolean
  'allow_change_order_after_departure', //boolean
  'allow_change_order_after_departure_hour', //number
  'limit_order_start_time', //string
  'tax_rate',
];

export const sms_params = ['sender_id', 'user_app', 'operator_app'];
export const user_app_params = [
  'user_app_listing',
  'user_app_status',
  'user_app_booking',
  'user_app_booking_message',
  'user_selling_start',
];

export const operator_app_params = [
  'op_app_listing',
  'op_app_status',
  'op_app_booking',
  'op_app_booking_message',
  'op_selling_start',
];

export const entity_app_params = [
  {
    name: 'User app',
    label: 'user',
  },
  {
    name: 'Operator app',
    label: 'op',
  },
];

export const list_app_params = [
  [
    'user_app_listing',
    'user_app_status',
    'user_app_booking',
    'user_app_booking_message',
    'user_selling_start',
    'user_custom_stt',
  ],
  [
    'op_app_listing',
    'op_app_status',
    'op_app_booking',
    'op_app_booking_message',
    'op_selling_start',
    'op_custom_stt',
  ],
];

export const route_markets = {
  yobuma: 'yobuma',
  agent: 'agent',
};

export const Roles = {
  super: 'super',
  admin: 'admin',
  staff: 'staff',
  customer: 'customer',
  operator: 'operator',
  agent: 'agent',
};

export const socials = {
  facebook: 'facebook',
  twitter: 'twitter',
  tiktok: 'tiktok',
  instagram: 'instagram',
};
export const site_params = [
  'meta_title',
  'meta_description',
  'meta_keywords',
  'before_head',
  'before_body',
  'og_image',
  'ga_id',
];

export const PUSHER_APP_KEY = '9c74126995eed5c7e4cb';

export const post_params = ['meta_description', 'meta_keywords', 'schema_type'];
export const tour_params = ['schema_type', 'meta_description', 'meta_keywords'];

export const menu_params = [
  'image',
  'title',
  'sub_title',
  'meta_title',
  'meta_description',
  'meta_keywords',
];

export const BillType = {
  COLLECT: 'collect',
  PAYMENT: 'payment',
};

export const PaymentTypes = {
  deposited: {
    status: 'deposited',
    color: 'geekblue',
  },
  full: {
    status: 'full',
    color: 'cyan',
  },
};

export const BillStatus = {
  pending: {
    status: 'pending',
    color: '#2db7f5',
  },
  approved: {
    status: 'approved',
    color: '#87d068',
  },
};

export const BillTypes = {
  income: {
    status: 'income',
    color: 'geekblue',
  },
  expense: {
    status: 'expense',
    color: 'cyan',
  },
};

export const TransactionTypes = {
  debit: {
    status: 'debit',
    color: 'geekblue',
  },
  pay: {
    status: 'pay',
    color: 'cyan',
  },
};

export const VoucherStatus = {
  not_send: {
    status: 'not_send',
    color: '#2db7f5',
  },
  sent: {
    status: 'sent',
    color: '#87d068',
  },
};

export const CabinPriceTypes = {
  cabin: 'cabin',
  seat: 'seat',
};

export const LocalStorageKeys = {
  order_list: 'order_list',
  booking_statistics: 'booking_statistics',
  booking_seats: 'booking_seats',
};

export const dataSchema_type = [
  'TouristDestination',
  'TouristAttraction',
  'LandmarksOrHistoricalBuildings',
  'TouristTrip',
  'Review',
  'FAQPage',
  'Hotel',
  'HotelRoom',
  'TrainTrip',
];

export const image_fallback =
  'data:image/png;base64,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';

export const AccountType = {
  debt: '131',
  revenue: '511',
  cash: '111',
};

export const ActionTypes = {
  create_booking: 'Create booking',
  amend_booking: 'Amend booking',
  payment_income: 'Payment',
  payment_expense: 'Refund',
  penalty: 'Penalty',
  cancel_return_trip: 'Cancel return trip',
  cancel_booking: 'Cancel booking',
  approve_payment_income: 'Approve payment',
  approve_payment_expense: 'Approve refund',
  refund_recording: 'Refund recording',
};

export const meetingPointType = {
  PICKUP_OFFER: '1',
  MEETING_POINT: '2',
  BOTH: '3',
};

export const priceType = {
  return: 'return',
  flat: 'flat',
};

export const SupplierStatus = {
  pending: {
    status: 'pending',
    color: '#2db7f5',
  },
  confirmed: {
    status: 'confirmed',
    color: '#87d068',
  },
  cancelled: {
    status: 'cancelled',
    color: 'error',
  },
};

export const TourTypes = {
  Tour: 'tour',
  Activity: 'activity',
  Ticket: 'ticket',
  Transport: 'transport',
};

export const OptionUnits = {
  CABIN: 'cabin',
  VEHILCE: 'vehicle',
  ROOM: 'room',
  SEAT: 'seat',
  BED: 'bed',
  PERSON: 'person',
};

export const ReviewStatus = {
  pending: {
    status: 'pending',
    color: '#2db7f5',
  },
  approved: {
    status: 'approved',
    color: '#87d068',
  },
};

export const VehicleType = {
  TRAIN: 'train',
  FOURSEAT: '4seat',
  SEVENSEAT: '7seat',
  NINESEAT: '9seat',
  SIXTEENSEAT: '16seat',
  TWENTYNINESEAT: '29seat',
  FERRY: 'ferry',
};

export const rateUsd = {
  vnd: 25, //units of thousands
};

export const pay_method = {
  OM: 'om',
  WAVE: 'wave',
  AGENT: 'agent',
  KPAY: 'kpay',
  CASH: 'cash',
};

export const chartType = {
  REVENUE: 'revenue',
  PASSENGERS: 'passengers',
  FILLING_RATE: 'filling_rate',
  TRIPS: 'trips',
};

export const chartSalesType = {
  TOTAL: 'total',
  YOBUMA: 'yobuma',
  CASHIER: 'caissier',
  BAGAGES: 'bagages',
};

export const dataSearchType = [
  {
    value: 'order_no',
    label: 'Ref',
  },
  {
    value: 'mobile',
    label: 'Phone',
  },
];

export const dataDateType = [
  {
    value: 'booking',
    label: 'Réservation',
  },
  {
    value: 'travel',
    label: 'Voyage',
  },
];
